import { STATUS_ENUM } from '../../constants'
import { notify } from '../../helpers'

const supabaseGetSingleItem = async (supabaseClient, tableName, id) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select()
      .eq('user_id', id)
      .single()
    return response?.data
  } catch (error) {
    console.error('error', error, supabaseClient, tableName, id)
  }
}
const supabaseGetSingleCompanyItem = async (supabaseClient, tableName, id) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select()
      .eq('user_id', id)
      .not('status', 'is', null)
      .neq('status', 'Declined')
      .single()
    return response?.data
  } catch (error) {
    console.error('error', error, supabaseClient, tableName, id)
  }
}
const supabaseGetItem = async (supabaseClient, tableName, id) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select()
      .eq('id', id)
      .single()
    return response?.data
  } catch (error) {
    console.error('error', error, supabaseClient, tableName, id)
  }
}
const supabaseAddItem = async (supabaseClient, tableName, data) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .insert(data)
      .select()
      .single()
    return response
  } catch (error) {
    console.error('error', error)
  }
}

const supabaseDeleteItem = async (supabaseClient, tableName, id) => {
  try {
    await supabaseClient.from(tableName).delete().eq('id', id).throwOnError()
  } catch (error) {
    console.log('error', error)
  }
}

const supabaseUpdateItem = async (supabaseClient, tableName, id, data) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .update(data)
      .eq('id', id)
    return response
  } catch (error) {
    console.error('error', error)
  }
}
const supabaseGetAllItemsById = async (
  supabaseClient,
  tableName,
  id,
  orderBy,
) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select('*')
      .match({ company_id: id })
      .order(orderBy, { ascending: true })
    return response?.data
  } catch (error) {
    console.error('error', error)
  }
}
const supabaseGetAllItemsByOrder = async (supabaseClient, tableName) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select('*')
      .order('order', { ascending: true })
    return response?.data
  } catch (error) {
    console.error('error', error)
  }
}
const supabaseGetAllItems = async (supabaseClient, tableName) => {
  try {
    const response = await supabaseClient.from(tableName).select('*')
    return response?.data
  } catch (error) {
    console.error('error', error)
  }
}
const supabaseGetAllByValue = async (
  supabaseClient,
  tableName,
  column,
  value,
  columns,
) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select(columns)
      .eq([column], value)
      .single()
    return response?.data
  } catch (error) {
    console.log('error', error)
  }
}
const supabaseGetAllItemsByValue = async (
  supabaseClient,
  tableName,
  column,
  value,
  columns = '*',
) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select(columns)
      .match({ [column]: value })
    return response?.data
  } catch (error) {
    console.log('error', error)
  }
}
async function checkImage(supabaseClient, storage, imageName) {
  const { data, error } = await supabaseClient.storage.from(storage).list('', {
    limit: 100,
    offset: 0,
    sortBy: { column: 'name', order: 'asc' },
    search: imageName,
  })

  if (error) {
    console.error('Error fetching files:', error)
  } else {
    return data
  }
}
async function setImageInStorage(supabaseClient, table, image) {
  const { data, error } = await supabaseClient.storage
    .from(table)
    .upload(image.name, image, {
      cacheControl: '3600',
      upsert: false,
    })
}
async function downloadImage(value, supabaseClient, path, bucket) {
  if (value) {
    try {
      const { data, error } = await supabaseClient.storage
        .from(bucket)
        .getPublicUrl(path)

      // if (error) throw error
      return data?.publicUrl
    } catch (error) {
      console.error('Error downloading image:', error, path, bucket)
      throw error
    }
  }
}
async function setImageInSupabaseTable(
  supabaseClient,
  imagePath,
  weekId,
  table,
) {
  const { data, error } = await supabaseClient
    .from(table)
    .update([{ image_url: imagePath }])
    .eq('id', weekId)
    .select()

  if (error) {
    console.error('Error storing the image path', error)
  }
}
const setPageData = async (value, supabaseClient, content) => {
  const data = await supabaseUpdateItem(
    supabaseClient,
    'program_content',
    value.id,
    {
      content: content,
    },
  )
}

const openFileInput = (id) => {
  const fileInput = document.getElementById(id)
  fileInput.click()
}
const getWeekId = async (supabaseClient, id) => {
  try {
    let { data: program } = await supabaseClient
      .from('program')
      .select('id')
      .eq('week_number', id)
    return program[0].id
  } catch (error) {
    console.error('Error getting week data', error)
  }
}
const supabaseGetItemsByWeekId = async (supabaseClient, tableName, id) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select('*')
      .match({ week_id: id })
    return response?.data
  } catch (error) {
    console.error('error', error)
  }
}
const handleDelete = async (id, supabaseClient, table) => {
  try {
    await supabaseClient.from(table).delete().match({ id: id })
  } catch (error) {
    console.error('Error deleting the playbook:', error)
  }
}

const supabaseGetAllItemsInRange = async (
  supabaseClient,
  tableName,
  column,
  value,
  columns = '*',
) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select(columns)
      .in([column], value)
    return response?.data
  } catch (error) {
    console.log('error', error)
  }
}
const supabaseGetItemInRange = async (
  supabaseClient,
  tableName,
  column,
  value,
  columns = '*',
  unique,
) => {
  try {
    const response = await supabaseClient
      .from(tableName)
      .select(columns)
      .eq('user_id', unique)
      .in([column], value)
      .single()
    return response?.data
  } catch (error) {
    console.log('error', error)
  }
}
const supabaseCreateNewCompany = async (
  supabaseClient,
  companiesData,
  companySummaryData,
  applicationID,
) => {
  try {
    let userID = companySummaryData?.user_id ?? companiesData?.user_id
    if (!userID) {
      const application = await supabaseGetItem(
        supabaseClient,
        'applications',
        applicationID,
      )
      userID = application?.user_id

      if (!userID) {
        notify('error', 'User ID not found. Please try again.')
        throw new Error('User ID not found. Please try again.')
      }
    }

    // Get company ID from the data (it should be in companySummaryData.id or companiesData.id)
    const companyID = companySummaryData?.id ?? companiesData?.id

    const insertTable1 = supabaseClient
      .from('companies')
      .insert({ ...companiesData, user_id: userID })
    const insertTable2 = supabaseClient
      .from('company_summary')
      .insert({ ...companySummaryData, user_id: userID })

    const [resultTable1, resultTable2] = await Promise.all([
      insertTable1,
      insertTable2,
    ])

    // Automatically add the founder to the company team
    if (companyID && userID) {
      try {
        await supabaseClient.from('company_team').upsert({
          id: userID + companyID,
          member_id: userID,
          position: 'owner',
          company_id: companyID,
          invited_by: userID,
          invited_by_company_id: companyID,
          invitation_status: STATUS_ENUM.accepted,
        })
      } catch (teamError) {
        // Log error but don't fail the entire operation if team upsert fails
        console.warn('Error adding founder to company team:', teamError)
      }
    }

    return {
      table1Result: resultTable1.data,
      table2Result: resultTable2.data,
    }
  } catch (error) {
    console.error('Error inserting data:', error)
    throw error
  }
}

const getDowloadedUrl = async (supabase, path, buket) => {
  try {
    const { data, error } = await supabase.storage.from(buket).download(path)
    if (error) {
      throw error
    }

    const url = URL.createObjectURL(data)
    return url
  } catch (error) {
    console.error('Error downloading image: ', error)
  }
}

const supabaseGetUserTeams = async (supabase, userId) => {
  try {
    if (!userId) return null

    const { data: invitations } = await supabase
      .from('company_team')
      .select('*, users(name, avatar_url,email)')
      .eq('member_id', userId)
      .ilike('invitation_status', STATUS_ENUM.accepted)
    const c = await Promise.all(
      invitations?.map(async (el) => {
        const inV = invitations?.filter(
          (invitation) =>
            (invitation.invited_by_company_id || invitation.company_id) ===
            (el.invited_by_company_id || el.company_id),
        )
        const company = await supabaseGetItem(
          supabase,
          'company_summary',
          el.invited_by_company_id || el.company_id,
        )
        return { ...company, company_team: inV }
      }),
    )

    const promises = c?.map(async (comp) => {
      let logoUrl = null
      if (comp?.logo_url) {
        logoUrl = await getDowloadedUrl(supabase, comp.logo_url, 'avatars')
      }
      return {
        company_id: comp.id,
        company_name: comp.company_name,
        logo: logoUrl,
      }
    })
    let companyData = await Promise.all(promises)
    companyData = companyData?.filter((el) => el)
    return companyData
  } catch (error) {
    console.log('🚀 ~ supabaseGetUserTeams ~ error:', error)
    throw error
  }
}

export {
  supabaseAddItem,
  supabaseDeleteItem,
  supabaseUpdateItem,
  supabaseGetAllItems,
  supabaseGetAllItemsById,
  supabaseGetAllItemsByValue,
  checkImage,
  downloadImage,
  setImageInSupabaseTable,
  setPageData,
  openFileInput,
  getWeekId,
  supabaseGetItemsByWeekId,
  setImageInStorage,
  handleDelete,
  supabaseGetAllItemsInRange,
  supabaseCreateNewCompany,
  supabaseGetUserTeams,
  supabaseGetItem,
  supabaseGetSingleItem,
  supabaseGetSingleCompanyItem,
  supabaseGetAllByValue,
  supabaseGetAllItemsByOrder,
  supabaseGetItemInRange,
}
